const TEST_ZONE_ENV_LETTERS = ['c'];
function envLetterOf(env) {
    var _a, _b;
    if (!env)
        return '';
    if (env === 'production')
        return 'p';
    if (env === 'test')
        return TEST_ZONE_ENV_LETTERS[0];
    const prefix = env.indexOf('-') > 0 ? env.split('-')[0] : env;
    return (_b = (_a = prefix.match(/^([a-z])\d*$/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
}
const browserDetectedEnvironment = () => { var _a, _b; return typeof window === 'undefined' ? undefined : (_b = (_a = window).detectEnvironment) === null || _b === void 0 ? void 0 : _b.call(_a); };
const currentEnvName = () => { var _a, _b, _c, _d; return (_d = (_a = browserDetectedEnvironment()) !== null && _a !== void 0 ? _a : (_c = (_b = globalThis.process) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c['NODE_ENV']) !== null && _d !== void 0 ? _d : ''; };
export const isTestZoneEnv = (env) => TEST_ZONE_ENV_LETTERS.includes(envLetterOf(env));
export const isTestZone = () => isTestZoneEnv(currentEnvName());
